import {NgModule} from '@angular/core';
import {GnLabelComponent} from './label.component';


@NgModule({
  declarations: [GnLabelComponent],
  exports: [GnLabelComponent],
  imports: [],
  entryComponents: []
})
export class GnLabelModule {
}
